class BurgerMenu extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".header-wrapper");
		this.burgerMenu = this.querySelector(".burger-menu");
		this.wrapper = this.querySelector(".burger-menu__wrapper");
		this.openButton = this.querySelector(".burger-menu__toggle--open-btn");
		this.closeButton = this.querySelectorAll(".burger-menu__toggle--close-btn");
		this.overlay = this.querySelector(".burger-menu__overlay");

		if (this.header) this.header.preventHide = false;

		this.setInitialState();
		this.setListeners();
	}

	open(event) {
		event?.preventDefault();
		if (!this.burgerMenu) return;

		if (this.header) this.header.preventHide = true;

		this.burgerMenu.classList.add("burger-menu--open");
		this.burgerMenu.setAttribute("aria-hidden", "false");
		this.openButton?.setAttribute("aria-expanded", "true");
		this.overlay?.classList.add("burger-menu__overlay--active");
		document.body.classList.add("overflow-hidden-drawer");
		this.wrapper?.focus({ preventScroll: true });
	}

	close(event) {
		event?.preventDefault();
		if (!this.burgerMenu) return;

		this.burgerMenu.classList.remove("burger-menu--open");
		this.burgerMenu.setAttribute("aria-hidden", "true");
		this.openButton?.setAttribute("aria-expanded", "false");
		this.overlay?.classList.remove("burger-menu__overlay--active");
		document.body.classList.remove("overflow-hidden-drawer");

		if (this.header) this.header.preventHide = false;

		this.burgerMenu.classList.add("hiding");

		setTimeout(() => this.burgerMenu.classList.remove("hiding"), 700);
		this.openButton?.focus({ preventScroll: true });
	}

	setInitialState() {
		this.burgerMenu?.setAttribute("aria-hidden", "true");
		this.openButton?.setAttribute("aria-expanded", "false");
	}

	setListeners() {
		this.openButton?.addEventListener("click", (event) => this.open(event));
		this.closeButton?.forEach((item) =>
			item.addEventListener("click", (event) => this.close(event))
		);
		this.overlay?.addEventListener("click", (event) => this.close(event));
		this.burgerMenu?.addEventListener(
			"keyup",
			(event) =>
				(event.code === "Escape" || event.key === "Escape") && this.close(event)
		);
	}
}

if (!customElements.get("burger-menu")) {
	customElements.define("burger-menu", BurgerMenu);
}

document.addEventListener('DOMContentLoaded', function () {
  function triggerCartAnimation() {
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return;

    cartBubble.classList.remove('is-added');
    void cartBubble.offsetWidth;
    cartBubble.classList.add('is-added');

    setTimeout(() => {
      cartBubble.classList.remove('is-added');
    }, 600);
  }

  document.addEventListener('click', function(e) {
    const addToCartButton = e.target.closest(
      'button[name="add"], .product-form__submit, .add-to-cart, [data-add-to-cart]'
    );

    if (addToCartButton) {
      setTimeout(() => {
        triggerCartAnimation();
      }, 300);
    }
  });
});
